"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variant = _interopRequireDefault(require("@styled-system/variant"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* GRID_GAP sizes are defined by Design spec. */
var GRID_GAP = 10;
/*
  MAX_DESKTOP_WIDTH is defined by design spec.
  In effect, we want to keep our middle column's (main-start / main-end) desaktop max width to 1324.
  At the same time, we want to keep the minimum gutter to 42px.

  However, because full-start / main-start and main-end / full-end are grid columns, they
  have gaps of 10px between them (see grid-gap below).

  We therefore need to remove 10 px from each side for a total of 20 from the calculated max.
  */

var MAX_DESKTOP_WIDTH = "".concat(1324 - GRID_GAP * 2, "px");
/**
 * @typedef {'default' | 'body'} variant
 */

/**
 * GridContainer sets up our standard 4/12 column grids for mobile/desktop.
 * These columns are labeled [col-start #] / [col-end #] respectively.
 * It also accepts a variant prop. This prop is an emun ['body', 'full'].
 * 
 * The 4/12 column layout on the body variant is constrained to the middle of the screen, 
 * and includes responsive margins.
 * The body variant includes [full-start]/[full-end] and [main-start]/[main-end] grid-columns.
 * 
 * @param {object} props
 * @param {{ 'body' | 'full' }} props.variant - variant enum of ['body', 'full']
 * @returns {React.Element}
 */

var GridContainer = (0, _styledComponents["default"])('div').attrs(function (props) {
  return {
    className: "gf_styled__GridContainer__".concat(props.variant)
  };
}).withConfig({
  displayName: "grid-container__GridContainer",
  componentId: "xh1u3n-0"
})(["position:relative;display:grid;width:100%;grid-column-gap:", "px;grid-template-columns:var(--mobile-grid);@media ", "{grid-template-columns:var(--desktop-grid--constrained);}@media (min-width:", "){grid-template-columns:var(--desktop-grid)}", ""], GRID_GAP, function (props) {
  return props.theme.queries.desktopAndUp;
}, MAX_DESKTOP_WIDTH, function (props) {
  return (0, _variant["default"])({
    variants: {
      body: {
        '--mobile-grid': "\n          [full-start main-start]\n            repeat(4, [col-start] minmax(0, 1fr) [col-end])\n          [main-end full-end];",
        '--desktop-grid--constrained': "\n          [full-start gutter-start main-start]\n            repeat(12, [col-start] minmax(0, 1fr) [col-end])\n          [full-start gutter-end main-end];",
        '--desktop-grid': "\n          [full-start gutter-start main-start]\n            repeat(12, [col-start] minmax(0, 1fr) [col-end])\n          [full-start gutter-end main-end];"
      },
      full: {
        // account for grid gap and convert to rems.
        '--mobile-grid': "\n          [full-start gutter-start]\n            ".concat(props.theme.gutters.mobile - GRID_GAP, "px\n              [main-start]\n                repeat(4, [col-start] minmax(0, 1fr) [col-end])\n              [main-end]\n              ").concat(props.theme.gutters.mobile - GRID_GAP, "px\n          [full-end gutter-end];"),
        '--desktop-grid--constrained': "\n          [full-start gutter-start]\n            ".concat(props.theme.gutters.desktop - GRID_GAP * 2, "px\n              [main-start]\n                repeat(12, [col-start] minmax(0, 1fr) [col-end])\n              [main-end]\n            ").concat(props.theme.gutters.desktop - GRID_GAP * 2, "px\n          [full-end gutter-end];"),
        '--desktop-grid': "\n          [full-start]\n            minmax(\n              0,\n              calc((100vw - ".concat(MAX_DESKTOP_WIDTH, ")/2)\n            )\n              [gutter-start]\n                ").concat(props.theme.gutters.desktop - GRID_GAP * 2, "px\n              [main-start]\n                repeat(12, [col-start] minmax(0, 1fr) [col-end])\n              [main-end]\n                ").concat(props.theme.gutters.desktop - GRID_GAP * 2, "px\n              [gutter-end]\n            minmax(\n              0,\n              calc((100vw - ").concat(MAX_DESKTOP_WIDTH, ")/2)\n            )\n          [full-end];")
      }
    }
  });
});
GridContainer.propTypes = {
  /** Switches between variants.
   * `default` does not include left/right margins/
   * `body` includes left/right margins, and  constrains center content based on viewport width.
   * See XD Design docs for additional information or refer to `grid-container.less`.
   */
  variant: _propTypes["default"].oneOf(['body', 'full']).isRequired
};
GridContainer.defaultProps = {
  variant: 'body'
};
var _default = GridContainer;
exports["default"] = _default;